"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _mapProductDataNew = _interopRequireDefault(require("@deosite/helpers/mapProductDataNew"));
var _agent = require("@deosite/agent");
var _createSearchUrl = require("@deosite/helpers/createSearchUrl");
var fetcher = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(_ref) {
    var skus, language, _ref$pageSize, pageSize, _ref$getQuantity, getQuantity, _ref$visibility, visibility, productsBySkusMapped, productsBySkus;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            skus = _ref.skus, language = _ref.language, _ref$pageSize = _ref.pageSize, pageSize = _ref$pageSize === void 0 ? 10 : _ref$pageSize, _ref$getQuantity = _ref.getQuantity, getQuantity = _ref$getQuantity === void 0 ? false : _ref$getQuantity, _ref$visibility = _ref.visibility, visibility = _ref$visibility === void 0 ? false : _ref$visibility;
            productsBySkusMapped = [];
            if (skus) {
              _context.next = 4;
              break;
            }
            return _context.abrupt("return", productsBySkusMapped);
          case 4:
            _context.prev = 4;
            _context.next = 7;
            return _agent.requests.get("".concat((0, _createSearchUrl.createSearchUrl)("/products", [{
              field: "sku",
              condition_type: "in",
              value: skus,
              connector: _createSearchUrl.CONNECTORS.AND
            }, {
              field: "type_id",
              value: "simple",
              connector: _createSearchUrl.CONNECTORS.AND
            }, visibility ? {} : {
              field: "visibility",
              condition_type: "in",
              value: [2, 4],
              connector: _createSearchUrl.CONNECTORS.AND
            }, {
              pageSize: pageSize
            }])).concat(getQuantity ? "&additionalFields=qty" : ""), getQuantity ? false : global.__appConfig__.elasticEnabled, null, language);
          case 7:
            productsBySkus = _context.sent;
            if (productsBySkus.total_count > 0) {
              productsBySkusMapped = (0, _mapProductDataNew["default"])(productsBySkus.items);
            } else {
              productsBySkusMapped = [];
            }
            _context.next = 15;
            break;
          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](4);
            console.log("There was an error while fetching products by skus ".concat(skus));
            productsBySkusMapped = [];
          case 15:
            return _context.abrupt("return", productsBySkusMapped);
          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[4, 11]]);
  }));
  return function fetcher(_x) {
    return _ref2.apply(this, arguments);
  };
}();
var _default = fetcher;
exports["default"] = _default;